import { IOperation } from '@/contracts/system-modules/sync/operation/IOperation'
import { IFoldNode, INodeState } from '@/contracts/modules/libre/use-case/IFoldNode'
import { EnumLibreEvent } from '@/contracts/modules/libre/enum/EnumLibreEvent'

function compareTime(a: string, b: string): number {
  return a < b ? -1 : a > b ? 1 : 0
}

/** Шифротекст переносится как есть; не строка — пустая строка */
function asCipher(value: unknown): string {
  return typeof value === 'string' ? value : ''
}

/**
 * Свёртка событий одного узла. События — факты в порядке меток: повтор по метке пропускается,
 * порядок доставки значения не имеет. Место (created, moved) и данные (created, changed)
 * сворачиваются порознь по поздней метке, поэтому перенос на одном устройстве и правка на
 * другом не теряются. Шифротексты свёртка не разбирает. Ключ — из первого по метке created.
 */
export class FoldNode implements IFoldNode {
  exec(operations: IOperation[]): INodeState {
    const byTime = new Map<string, IOperation>()
    operations.forEach((operation) => byTime.set(operation.time, operation))
    const ordered = [...byTime.values()].sort((a, b) => compareTime(a.time, b.time))

    const state: INodeState = { key: null, place: '', data: '', isRemoved: false, updatedAt: null }
    ordered.forEach((operation) => {
      switch (operation.event) {
      case EnumLibreEvent.CREATED:
        if (state.key === null) {
          state.key = asCipher(operation.fields.key) || null
        }
        state.place = asCipher(operation.fields.place)
        state.data = asCipher(operation.fields.data)
        break
      case EnumLibreEvent.MOVED:
        state.place = asCipher(operation.fields.place)
        break
      case EnumLibreEvent.CHANGED:
        state.data = asCipher(operation.fields.data)
        break
      case EnumLibreEvent.REMOVED:
        state.isRemoved = true
        break
      case EnumLibreEvent.RESTORED:
        state.isRemoved = false
        break
      default:
        return
      }
      state.updatedAt = operation.time
    })

    return state
  }
}
